<div class="d-flex flex-column justify-content-center align-items-center white_box shadow p-3">
    <div class="form-group col-sm-6 mb-3">
        <label for=""><p style="font-size: 1.4rem; font-weight: bold;"><i class="fa-solid fa-comments"></i> Message to be added</p></label>
        <textarea rows="3"  ngRequr type="text" [(ngModel)]="messageToBeAdded" [ngModelOptions]="{ standalone: true }"
          class="form-control"  placeholder="Message to be added"></textarea>
         
    </div>
    <div class="d-flex align-items-center mb-2">
        <input type="checkbox" id="isForLoginUserOnly" [(ngModel)]="isForLoginUserOnly" class="custom-checkbox"/>
        <label class="ml-2 mb-0" for="isForLoginUserOnly">Only show for logged-in users</label>
      </div>
      
    <button (click)="addMessage()" class="btn btn-success"><i class="fas fa-save"></i> Add Message</button>

</div>

<table class="table table-striped">
    <thead>
      <tr>
        <th scop="col">Message</th>
        <th scop="col">Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let message of messages">
        <td>{{message.message}}</td>
        <td>
          <button (click)="deleteBizMessage(message.id)" class="btn btn-error"> <i class="fa fa-trash" style="color: red" aria-hidden="true"></i></button>
        
        </td>
      </tr>

    </tbody>
</table>